import CancelIcon from '@mui/icons-material/Cancel'
import DoneIcon from '@mui/icons-material/Done'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import HourglassDisabledIcon from '@mui/icons-material/HourglassDisabled'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import NoEncryptionIcon from '@mui/icons-material/NoEncryption'
import { Chip } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'

type RequestStatusType = 'OPEN' | 'IN_BEHANDELING' | 'GEWEIGERD' | 'INGETROKKEN' | 'GEREEDGEMELD' | 'GEREED'

interface RequestStatusChipProps {
  status: string | null | undefined
  label?: boolean
}

const RequestStatusChip: FC<RequestStatusChipProps> = ({ status, label = true }) => {
  const translate = useTranslate()

  const colorMap: Record<RequestStatusType, 'success' | 'warning' | 'info' | undefined> = {
    OPEN: 'warning',
    IN_BEHANDELING: undefined,
    GEWEIGERD: 'warning',
    INGETROKKEN: undefined,
    GEREEDGEMELD: 'success',
    GEREED: 'success',
  }

  const iconMap: Record<RequestStatusType, JSX.Element> = {
    OPEN: <HourglassDisabledIcon fontSize="small" />,
    IN_BEHANDELING: <HourglassEmptyIcon fontSize="small" />,
    GEWEIGERD: <CancelIcon fontSize="small" />,
    INGETROKKEN: <NoEncryptionIcon fontSize="small" />,
    GEREEDGEMELD: <DoneAllIcon fontSize="small" />,
    GEREED: <DoneIcon fontSize="small" />,
  }

  if (!status) {
    return <span />
  }

  return (
    <Chip
      label={label ? translate(`resources.collaborations.requestStatus.${status}`) : ''}
      color={colorMap[status as RequestStatusType]}
      icon={iconMap[status as RequestStatusType]}
      variant={'outlined'}
      sx={ !label ? { pl: 1 } : {} }
      size="small"
    />
  )
}

export default RequestStatusChip
